import { useEffect } from 'react'

import { useSearchParams } from 'react-router-dom'

import styles from './index.module.less'

const GoogleCallback = () => {
  const [searchParams] = useSearchParams()

  const handleSetLocalStorage = (key: string, content: string) => {
    if (typeof content !== 'string') {
      localStorage.setItem(key, JSON.stringify(content))
    } else {
      localStorage.setItem(key, content)
    }
  }

  useEffect(() => {
    const handleCallback = () => {
      try {
        const callback_code = searchParams.get('code')
        const callback_error = searchParams.get('error')
        // 失败
        if (callback_error) {
          if (window.opener) {
            window.opener.postMessage(
              {
                type: 'google_error',
                error: callback_error || 'error'
              },
              window.location.origin
            )
          } else {
            handleSetLocalStorage('google_error', callback_error)
          }
          window.close()
          return
        }

        // 成功
        if (callback_code) {
          if (window.opener) {
            window.opener.postMessage(
              {
                type: 'google_success',
                code: callback_code
              },
              window.location.origin
            )
          } else {
            // 当window.opener为null时 采用localStorage让主窗口监听storage事件得知登录状态
            handleSetLocalStorage('google_success', callback_code)
          }
        }
        // 关闭弹窗
        window.close()
      } catch (e) {
        console.error('googleerror', e)
        if (window.opener) {
          window.opener.postMessage(
            {
              type: 'google_error',
              error: 'Callback processing failed'
            },
            window.location.origin
          )
        } else {
          handleSetLocalStorage(
            'google_error',
            e instanceof Error ? e.message : String(e)
          )
        }

        window.close()
      }
    }
    handleCallback()
  }, [searchParams])

  return (
    <div className={styles.googleCallbackContainer}>
      <div className={styles.googleCallbackSpinner}></div>
      <div>Completing FaceBook login...</div>
    </div>
  )
}

export default GoogleCallback
